import { toast, type ToastContainerOptions } from 'vue3-toastify';
import type { Options } from 'vue3-toastify';
import 'vue3-toastify/dist/index.css';

const defaultOptions: ToastContainerOptions = {
  position: 'top-right',
  theme: 'auto',
  autoClose: 2000,
  icon: true,
  limit: 2,
  transition: 'flip',
  clearOnUrlChange: false
}

export const successToast = (message: string, options?: Options) => {
  toast.success(message, { 
    autoClose: 500,
    position: 'top-center',
    ...defaultOptions,
    ...options, 
    theme: getTheme() 
  });
}

export const errorToast = (message: string, options?: Options) => {

  toast.error(message, {
    autoClose: 4000,
    ...defaultOptions,
    ...options,
    theme: getTheme(),
  });
}

export const infoToast = (message: string, options?: Options) => {
  toast.info(message, { 
    autoClose: 4000,
    ...defaultOptions,
    ...options, 
    theme: getTheme() 
  });
}

export const warnToast = (message: string, options?: Options) => {
  toast.warning(message, {
    autoClose: 4000, 
    ...defaultOptions,
    ...options, 
    theme: getTheme() 
  });
}

const getTheme = () => document.documentElement.getAttribute('data-theme') === 'dark' ? 'dark' : 'light';